import { isCommission } from '../types/commission.js';
import { recalculateRetailBalance } from './recalculate-retail-balance.js';

/**
 * Function to generate an array of commission percentage options based on the sold shares, share price, and maximum commission.
 *
 * @param soldShares Number of shares sold
 * @param sharePrice Price per share
 * @param maxCommission Maximum commission percentage
 * @returns Array of commission percentage options
 */
export function calculateRetailCommissionOptions(
  soldShares: number,
  sharePrice: number,
  maxCommission: number
): number[] {
  const commissionPercentOptions = [];
  for (let i = 0; i <= maxCommission; i++) {
    if (!isCommission(i)) {
      continue;
    }
    commissionPercentOptions.push(recalculateRetailBalance(soldShares, sharePrice, i));
  }
  return commissionPercentOptions;
}
